const ReportTypeOptions = [
  {
    value: "DQG",
    label: "Simple Profiling",
  },
  {
    value: "Pandas",
    label: "Detailed Profiling",
  },
  {
    value: "scatterplot",
    label: "Scatter Plot",
  },
  {
    value: "boxplot",
    label: "Box Plot",
  },
  {
    value: "Piechart",
    label: "Pie Chart",
  },
  {
    value: "Barplot",
    label: "Bar Chart",
  },
  {
    value: "Histogram",
    label: "Histogram",
  },
  // {
  //   value: "Movablebarplot",
  //   label: "Movable Bar Graph",
  // },
  // {
  //   value: "LUX",
  //   label: "LUX",
  // },
  // {
  //   value: "Pairplot",
  //   label: "Pair Plot",
  // },
  // {
  //   value: "missing",
  //   label: "Visualization of missing values",
  // },
  // {
  //   value: "Correlation",
  //   label: "Correlation",
  // },
];

export default ReportTypeOptions;
